export const adaptTipoProfesionalEspecialidad = (tipoProfesionalEspecialidadData) => {
    return {
        id: tipoProfesionalEspecialidadData?.idTipoProfesionalEspecialidad,
        displayName: tipoProfesionalEspecialidadData?.nombre,
        name: tipoProfesionalEspecialidadData?.nombre
    }
}

export const adaptTipoProfesionalEspecialidadArray = (tipoProfesionalesEspecialidad) => {
    return structuredClone(tipoProfesionalesEspecialidad?.allTipoProfesionalEspecialidad)
        ?.map(tipoProfesionalEspecialidad => adaptTipoProfesionalEspecialidad(tipoProfesionalEspecialidad));
}

export const adaptEspecialidadesProfesionalArray = (data) => {
    return structuredClone(data?.tipoProfesionalEspecialidad)
        ?.map(tipoProfesionalEspecialidad => adaptTipoProfesionalEspecialidad(tipoProfesionalEspecialidad));
}